import Workout from './Workout';

export default Workout;
